<template lang="html">
  <div>
    <div class="container">
      <div class="form-container">
        <el-form
          ref="nodeForm"
          :model="nodeForm"
          :rules="nodeFormRules"
          label-position="right"
          label-width="120px"
        >
          <el-form-item
            label="公告标题"
            prop="title"
          >
            <el-input
              v-model="nodeForm.title"
              placeholder="默认为“节目公告”"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="公告正文"
            prop="content"
          >
            <el-input
              type="textarea"
              v-model="nodeForm.content"
              :autosize="{ minRows: 3, maxRows: 40 }"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="发布时间"
            pop="created"
          >
            <el-input
              disabled
              v-model="nodeForm.created"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否隐藏"
            prop="hidden"
          >
            <el-switch
              v-model="nodeForm.hidden"
            ></el-switch>
          </el-form-item>
           <el-form-item>
              <el-button
                type="primary"
                @click="submitForm()"
              >提交</el-button>
              <span style="float:right;">
                <el-link
                  type="danger"
                  icon="el-icon-delete"
                  :underline="false"
                  @click="remove"
                >删除</el-link>
              </span>
            </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../router'
  import { Message } from 'element-ui'
  import { MessageBox } from 'element-ui'
  import { Link } from 'element-ui'
  import Vue from 'vue'
  Vue.use(Link)
  
  export default {
    components: {
  
    },
    data () {
      return {
        showSlug: this.$route.params.slug,
        noticeId: parseInt(this.$route.params.id),
        nodeForm: {},
        nodeFormRules: {
          title: [
            { required: false, message: '请输入标题', trigger: 'blur' },
            { max: 20, message: '长度不超过20个字符', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '请输入正文', trigger: 'blur' },
            { max: 2000, message: '长度不超过2000个字符', trigger: 'blur' }
          ],
        },
      }
    },
    computed: {},
    methods: {
      submitForm: function () {
        this.$refs.nodeForm.validate((valid) => {
          if (valid) {
            window.console.log(valid)
            this.$api.notice.update(
              this.nodeForm.id, this.nodeForm
            ).then(res => {
              window.console.log("Notice更新成功")
              window.console.log(res)
              router.replace({
              name: 'ResultSuccess',
              params: {
                title: '成功',
                subTitle: '公告已更新',
                action: {
                  title: '返回公告列表',
                  routeName: 'NoticeList'
                }
              }
            })
            })
          } else {
            window.console.log(valid)
            Message.error({
              message: `请检查表单填写是否正确、完整`
            })
          }
        })
      },
      remove: function () {
        let that = this
        window.console.log("remove")
        MessageBox.confirm('此操作将永久删除，是否确定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.console.log("开始删除...")
          that.$api.notice.delete(
            that.nodeForm.id
          ).then(res => {
            window.console.log("删除成功")
            window.console.log(res)
            router.replace({
              name: 'ResultSuccess',
              params: {
                title: '成功',
                subTitle: '公告已删除',
                action: {
                  title: '返回公告列表',
                  routeName: 'NoticeList'
                }
              }
            })
          }).catch(err => {
            window.console.log("删除失败")
            window.console.log(err)
          })
          // Message.success({
          //   message: '删除成功!'
          // });
        }).catch(() => {
          Message.info({
            message: '已取消删除'
          });          
        })
      }
    },
    mounted () {
      let that = this
      that.$api.notice.detail(that.$route.params.id).then(res => {
        window.console.log("获取到Notice Detail")
        window.console.log(res.data)
        let nodeForm = res.data
        that.nodeForm = nodeForm
      })
    }
  }
</script>

<style lang="css" scoped>
</style>
